import { gql } from '@apollo/client';
import { UPLOAD_FIELDS } from '../fragments';

const ACTIVITY_FIELDS = `
  id
  title
  type
  hasTextInput
  instruction
  embedLink
  dueDate
  submissionCount
  cohort {
    id
    name
  }
  subjects {
    id
    name
  }
`;

/**
 * Creating an activity also assigns it to the cohort's active learners, so
 * there is no second call to make and no window in which an activity exists
 * with nobody assigned to it.
 */
export const CREATE_ACTIVITY = gql`
  mutation createActivity($input: CreateActivityInputType!) {
    createActivity(input: $input) {
      ${ACTIVITY_FIELDS}
      uploads {
        ...UploadFields
      }
    }
  }
  ${UPLOAD_FIELDS}
`;

export const UPDATE_ACTIVITY = gql`
  mutation updateActivity($id: String!, $input: UpdateActivityInputType!) {
    updateActivity(id: $id, input: $input) {
      ${ACTIVITY_FIELDS}
      uploads {
        ...UploadFields
      }
    }
  }
  ${UPLOAD_FIELDS}
`;

export const DELETE_ACTIVITY = gql`
  mutation deleteActivity($id: String!) {
    deleteActivity(id: $id)
  }
`;

/**
 * The author is the token holder, and the server refuses an activity the
 * caller was not assigned — the old mutation took a nested `user.connect`.
 */
export const CREATE_ACTIVITY_SUBMISSION = gql`
  mutation createSubmission($activityId: String!, $input: CreateSubmissionInputType!) {
    createSubmission(activityId: $activityId, input: $input) {
      id
      status
      submission {
        status
        rating
        textContent
      }
    }
  }
`;

/** This one is grading, which is why it names a learner and is staff-only. */
export const UPDATE_ACTIVITY_SUBMISSION = gql`
  mutation gradeSubmission(
    $activityId: String!
    $userId: String!
    $input: GradeSubmissionInputType!
  ) {
    updateSubmission(activityId: $activityId, userId: $userId, input: $input) {
      id
      userId
      status
      user {
        id
        firstName
        lastName
        profileStudent {
          admissionNumber
        }
      }
      submission {
        status
        rating
        textContent
        createdAt
      }
    }
  }
`;

/**
 * Withdraws work; the assignment itself stays, so the activity does not
 * disappear from the learner's dashboard. `userId` is the grading screen
 * letting a learner hand in again, and is staff only — omitting it means the
 * caller's own.
 */
export const DELETE_ACTIVITY_SUBMISSION = gql`
  mutation deleteSubmission($activityId: String!, $userId: String) {
    deleteSubmission(activityId: $activityId, userId: $userId)
  }
`;
